<template>
    <span contenteditable="true"
          @blur="handleBlur"
          @keydown="handleKeydown"
          @keyup="handleKeyup"
          style="padding: 0 4px;"
          v-text="value"
    ></span>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        props: {
            update: {
                type: Function,
                required: false
            },

            field: {
                type: String,
                required: true
            },

            entity: {
                type: Object,
                required: true
            },

            multiline: {
                type: Boolean,
                required: false,
                default: false
            },

            required: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        watch: {
            entity: {
                immediate: true,
                deep: true,
                handler() {
                    this.mutatedValue = _.get(this.entity, this.field)
                }
            }
        },

        mounted() {
            this.mutatedValue = this.value
        },

        computed: {
            value() {
                return _.get(this.entity, this.field)
            },

            changed() {
                return this.value !== this.mutatedValue
            }
        },

        data() {
            return {
                mutatedValue: null,
                updating: false
            }
        },

        methods: {
            handleBlur() {
                if (this.changed) {
                    let payload = {
                        id: this.entity.id,
                        field: this.field
                    }
                    payload[this.field] = this.mutatedValue

                    this.updating = true

                    this.update(payload)
                        .then(res => {
                            this.updating = false
                            this.successMessage(_.startCase(this.field) + ' updated')
                            return res
                        })
                }
            },

            handleKeydown(e) {
                if (this.multiline === false && e.code == 'Enter') {
                    e.preventDefault()
                }
            },

            handleKeyup(e) {
                this.mutatedValue = e.target.innerText
            }
        }
    }
</script>

<style scoped>
    [contenteditable="true"]:active,
    [contenteditable="true"]:focus {
        border:none;
        outline:none;
    }
    [contenteditable="true"]:hover {
        cursor: pointer;
    }
</style>